import { render, staticRenderFns } from "./GroupsMain.vue?vue&type=template&id=55d870e6&"
import script from "./GroupsMain.vue?vue&type=script&lang=js&"
export * from "./GroupsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports